// CSS
import './Button.css';

import { Button as AntButton } from 'antd';
import PropTypes from 'prop-types';

const Button = ({ children, onClick, type, disabled, className }) => {
  Button.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    type: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string
  };

  return (
    <AntButton
      block={type || null}
      className={className ? `helbest-no-btn-border ${className}` : 'helbest-no-btn-border'}
      disabled={disabled || false}
      onClick={onClick}
      type="link">
      {children}
    </AntButton>
  );
};

export default Button;
